import React from 'react'

import aampeTheme from '../../constants/aampeTheme'

export default function InputError({ error }) {
    return (
        <div
            style={{
                color: 'red',
                fontSize: '12px',
                marginTop: aampeTheme.spacing4(2),
            }}
        >
            {error}
        </div>
    )
}
